export const CONTAINERS = {
  container1920: '1920px',
  contentContainer: '1620px',
  contentContainerLaptopM: '980px',
  contentContainerTablet: '678px',
  contentContainerMobileL: '85%',
};

export const BORDER_RADIUS = {
  radius25: '25px',
  radius18: '18px',
  radius16: '16px',
  radius14: '14px',
  radius12: '12px',
  radius8: '8px',
  radius100: '100%',
};
